"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const EmailIcon_module_css_1 = __importDefault(require("./EmailIcon.module.css"));
const EnvelopeIcon_svg_1 = __importDefault(require("./EnvelopeIcon.svg"));
/**
 * Email icon.
 * figma link - https://www.figma.com/file/UpS0VG7yUnr0VLopn0wBwx/Sharing-component?node-id=5028%3A13978
 */
function EmailIcon() {
    return ((0, jsx_runtime_1.jsx)("div", { className: EmailIcon_module_css_1.default.iconContainer, children: (0, jsx_runtime_1.jsx)("div", { className: EmailIcon_module_css_1.default.iconStyle, children: (0, jsx_runtime_1.jsx)(EnvelopeIcon_svg_1.default, {}) }) }));
}
exports.EmailIcon = EmailIcon;
//# sourceMappingURL=EmailIcon.js.map